module.exports = __webpack_public_path__ + "img/engelink_logo.cca240df.svg";